<script>

import MenuButton from '@/components/MenuButton';
import UtilitySearch from '@/components/UtilitySearchPorches';


export default {
    name: 'Header',
    components: {
        MenuButton,
        UtilitySearch,
    },
    data() {
    	return {
    		toggleTray: this.toggleTrayFunc,
    	}
    },
    methods:{
    	toggleTrayFunc(id) {
            var this_item = document.getElementById(id);
            var displayTray = 'true';
            
            if (this_item !== null || this_item !== 'undefined') {
                var this_tray = this_item.getElementsByClassName('nav__secondary--tray')[0];
                
                if (this_tray !== null || this_tray !== 'undefined') {
                    if (this_tray.style.opacity == '1') {
                        displayTray = 'false';
                    }
                }
                
                var doc_trays = document.getElementsByClassName('nav__secondary--tray');
                for (var i = 0; i < doc_trays.length; i++) {
                    doc_trays[i].style.opacity = '0';
                    doc_trays[i].style.pointerEvents = 'none';
                }

                var doc_tabs = document.getElementsByClassName('nav__secondary--list-item');
                for(var i = 0; i < doc_tabs.length; i++){
                    doc_tabs[i].classList.remove("active-tab");
                }

                if (displayTray == "true") {
                    this_tray.style.opacity = '1';
                    this_tray.style.pointerEvents = 'auto';
                    this_item.classList.add("active-tab");
                }
            }
        },
        //simple function that redirects the focus to the content when you skip to the page content
        skipToContentReFocusFunc(){
            document.getElementById("skiptoContentLink").blur();
            document.getElementById("skipToContent").focus();
        },
    }
};
</script>
<style
    lang="scss"
    src="../../scss/_liferay/header.scss"
></style>


// WEBPACK FOOTER //
// src/components/_liferay/Header.vue